import { easings } from "react-spring";
import { ScreenAlertContextState, ScreenAlertType } from "./types";

export const initialScreenAlertState: ScreenAlertContextState = {
  type: null,
  message: "",
  isOpen: false,
};

export const screenAlertReducer = (
  state: ScreenAlertContextState,
  action: {
    type: ScreenAlertType | "clear";
    payload?:
      | {
          message?: string;
        }
      | undefined
      | null;
  }
): ScreenAlertContextState => {
  switch (action.type) {
    case ScreenAlertType.Error:
    case ScreenAlertType.Warning:
    case ScreenAlertType.Info:
    case ScreenAlertType.Success:
      return {
        ...state,
        type: action.type,
        message: action.payload?.message || "",
        isOpen: true,
      };
    case "clear":
      return {
        ...state,
        type: null,
        message: "",
        isOpen: false,
      };
    default:
      return state;
  }
};

export const animationConfigByAlertType: Partial<Record<ScreenAlertType, any>> = {
  [ScreenAlertType.Success]: {
    tension: 300,
    friction: 30,
    duration: 500,
    easing: easings.easeInOutQuad,
  },
  [ScreenAlertType.Error]: {
    tension: 200,
    friction: 20,
    duration: 380,
    easing: easings.easeOutBounce,
  },
};
